import React, { useState, createContext } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import Navbar from "./components/Navbar.jsx";
import Footer from "./components/Footer.jsx";
import HomePage from "./pages/HomePage.jsx";
import AboutPage from "./pages/AboutPage.jsx";
import PrestationsPage from "./pages/PrestationsPage.jsx";
import PriseRDVAgenda from "./pages/PriseRDVAgenda/PriseRDVAgenda.jsx";
import ContactPage from "./pages/ContactPage.jsx";
import LoginPage from "./pages/LoginPage/LoginPage.jsx";
import AsideMenu from "./pages/Appli/AsideMenu.jsx";
import MainContent from "./pages/Appli/MainContent.jsx";
// import Diaporama from "./pages/Diaporama.jsx";
import NewsPage from "./pages/NewsPage.jsx";
import CGVPage from "./pages/CGVPage.jsx";

import { useUser, UserProvider } from "./contexts/UserContext";

// Context Providers
import { ContactFormProvider } from "./contexts/ContactFormContext";
import { AsideMenuProvider } from "./contexts/AsideMenuContext";
import { useAsideMenu } from "./contexts/AsideMenuContext";
import PrimaryColorProvider from "./hooks/PrimaryColorProvider.jsx";
import { NotificationToastProvider } from "./components/Notification/NotificationManager.jsx";
import { LanguageProvider } from "./contexts/LanguageContext";

// Import i18n for translations
import "./i18n"; // Assurez-vous que votre fichier de configuration i18n est correct.

export const ThemeContext = createContext();

const isAuthenticated = () => {
  const storedUser = localStorage.getItem("user");
  return storedUser ? JSON.parse(storedUser) : null;
};

const RequireAuth = ({ children }) => {
  const location = useLocation();
  const user = isAuthenticated();

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
};

function AppContent() {
  const { user } = useUser();
  const { isOpen } = useAsideMenu();
  const location = useLocation();

  return (
    <div className="flex flex-col min-h-screen">
      {!location.pathname.startsWith("/appli") && <Navbar user={user} />}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/prestations" element={<PrestationsPage />} />
          <Route path="/prise_rdv" element={<PriseRDVAgenda />} />
          {/* <Route path="/diaporama" element={<Diaporama />} /> */}
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/cgv" element={<CGVPage />} />

          <Route
            path="/appli/*"
            element={
              <RequireAuth>
                <div className="flex">
                  <AsideMenu />
                  <MainContent isMenuOpen={isOpen} />
                </div>
              </RequireAuth>
            }
          />
        </Routes>
      </main>
      {!location.pathname.startsWith("/appli") && <Footer />}
    </div>
  );
}

function App() {
  const [theme, setTheme] = useState("light");

  const toggleTheme = () => setTheme(theme === "light" ? "dark" : "light");

  return (
    <UserProvider>
      <ContactFormProvider>
        <AsideMenuProvider>
          <PrimaryColorProvider>
            <ThemeContext.Provider value={{ theme, toggleTheme }}>
              <LanguageProvider>
                <NotificationToastProvider>
                  <Router>
                    <div
                      className={`${theme} bg-bgbackground bg-repeat bg-center min-h-screen flex flex-col relative`}
                      style={{
                        // backgroundImage: "url('/images/fondweb5.webp')",
                        // backgroundSize: "2200px 1000px", // Taille spécifique du motif
                        // backgroundAttachment: "fixed", // Fixe le motif au viewport
                      }}
                    >
                      {/* Overlay sombre pour le mode dark */}
                      {theme === "dark" && (
                        <div
                          className="absolute top-0 left-0 w-full h-full z-0 pointer-events-none"
                          style={{
                            backgroundColor: "rgba(0, 0, 0, 0.5)", // Couleur sombre avec opacité
                          }}
                        ></div>
                      )}

                      {/* Le contenu de l'application */}
                      <div className="relative z-10 flex-grow">
                        <AppContent />
                      </div>
                    </div>
                  </Router>
                </NotificationToastProvider>
              </LanguageProvider>
            </ThemeContext.Provider>
          </PrimaryColorProvider>
        </AsideMenuProvider>
      </ContactFormProvider>
    </UserProvider>
  );
}

export default App;
